import React, { useState } from 'react';
import { makeStyles, Grid, Button, Box, CircularProgress } from '@material-ui/core';
import { injectIntl } from 'react-intl';

import { useSelector } from 'react-redux';
import { SERVICES_CODES } from 'app/config/services';
import { STATUS_CODES } from 'app/config/status';

import styles from './styles';
const useStyles = makeStyles(styles);

function SaveButton({
  mainColor,
  hideActionBtn,
  isInternalForm,
  canEdit,
  onCancel,
  onSave,
  cancelLabel = 'Cancelar',
  saveLabel = 'Salvar',
  sending = false,
}) {
  const classes = useStyles();

  const service = useSelector(state => state.services.details);
  const request = useSelector(state => state.requests.details);

  const [showSaveButton] = useState(() => {
    if (hideActionBtn) return false;
    if (isInternalForm) return canEdit;
    if (!canEdit) {
      if (
        service.cdServico === SERVICES_CODES.INATIVACAO_CADASTRAL ||
        service.cdServico === SERVICES_CODES.EXCLUSAO_VEICULOS
      ) {
        if (!request.situacao) return true; // new request
        return (
          request.situacao?.boEdicaoPortalExterno ||
          request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO
        );
      }
    }
    return canEdit;
  });

  const handleSave = () => {
    onSave();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <>
      {showSaveButton && (
        <Grid container spacing={3}>
          <div className={classes.actionsContainer}>
            {sending && (
              <Grid item xs={12} className={classes.centerProgress}>
                <CircularProgress size={16} />
              </Grid>
            )}
            {!sending && (
              <>
                <Grid item xs={12} sm={4}>
                  <Button className={classes.actionsBtns} onClick={handleCancel}>
                    {cancelLabel}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    disableElevation
                    variant="contained"
                    color={mainColor ? mainColor : 'primary'}
                    className={classes.actionsBtns}
                    onClick={handleSave}
                  >
                    <Box className={classes.colorWhite}>{saveLabel}</Box>
                  </Button>
                </Grid>
              </>
            )}
          </div>
        </Grid>
      )}
    </>
  );
}

export default injectIntl(SaveButton);
